import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { useCurrentUser } from "APP_ROOT/hooks";
import Form from "./Form";

export default function CreateConsignment({ open, close }) {
  const locationId = useCurrentUser().location_id;

  const initialValues = {
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    store_owner_id: locationId,
    store_location_id: locationId
  };

  return (
    <div>
      <Modal open={open} close={close} dialogClass="modal-lg">
        <Header>
          <Close close={close} />
          <h4 className="modal-title">Create a Consignment</h4>
        </Header>
        <Form close={close} initialValues={initialValues} />
      </Modal>
    </div>
  );
}

CreateConsignment.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Consignments/Search/Create/Create.jsx